import React, { Fragment, memo, Suspense, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";

import { RoutesList } from "./route-list";
import MainLayout from "../layout/main-layout";
import LoadingBarGIF from "../assets/loading-bar 1.gif";

const Loader = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        height: "100vh",
        alignItems: "center",
        background: "#000",
      }}
    >
      {/* <Spinner
        animation="border"
        role="status"
        style={{ width: "100px", height: "100px" }}
        variant="secondary"
        size="lg"
      >
        <span className="visually-hidden">Loading...</span>
      </Spinner> */}
      <img src={LoadingBarGIF} />
    </div>
  );
};

const RouterComponent = memo(() => {
  console.log = function () {};

  return (
    <div>
      <Fragment>
        <Suspense fallback={<Loader />}>
          <Router>
         
            <Routes>
             
              {RoutesList ? (
                RoutesList.map((itm, index) => (
                  <Route
                    key={index}
                    path={itm.path}
                    element={
                      <MainLayout
                        name={itm.name}
                        component={itm.layout}
                        isAuthProtected={itm.isAuthProtected}
                      />
                    }
                  />
                ))
              ) : (
                <Route path="*" element={<Loader />} />
              )}
              <Route path="*" element={<Loader />} />
            </Routes>
          </Router>
        </Suspense>
      </Fragment>
    </div>
  );
});

export default RouterComponent;
